import { IconBrandGoogle } from '@components/icons/brand-google';
import { IconEdit } from '@components/icons/edit';
import { IconRemove } from '@components/icons/remove';
import { SettingsCard } from '@components/settings-card';

import { useUpdateCompanyInfo } from 'api/companies/hooks';
import { useModal } from 'features/modals';
import { useStore } from 'models/Provider';
import { Company } from 'types/companies';

type GoogleAnalyticsTrackingCodeProps = {
  currentGaTracker: Company['gaTracker'];
};

export const GoogleAnalyticsTrackingCode = ({
  currentGaTracker,
}: GoogleAnalyticsTrackingCodeProps) => {
  const { t } = useStore();
  const { showModal } = useModal();
  const showEditModal = () =>
    showModal('EDIT_GOOGLE_ANALYTICS', {
      currentGaTracker,
    });
  const submit = useUpdateCompanyInfo({
    successMessage: t('company.settings.root.ga.updateSuccess'),
    errorMessage: t('company.settings.root.ga.updateError'),
  });

  return (
    <SettingsCard
      title={t('company.settings.root.ga.extendedtitle')}
      description={currentGaTracker ?? t('company.settings.root.ga.placeholder')}
      icon={<IconBrandGoogle />}
      actionItems={
        !currentGaTracker
          ? undefined
          : [
              {
                id: 'edit',
                icon: <IconEdit />,
                label: t('company.settings.root.ga.edit'),
                onSelect: showEditModal,
              },
              {
                id: 'remove',
                icon: <IconRemove />,
                label: t('company.settings.root.ga.remove'),
                onSelect: () => submit.mutate({ gaTracker: null }),
              },
            ]
      }
      onEdit={currentGaTracker ? undefined : showEditModal}
    />
  );
};
